import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useJobDetails } from "@/context/JobDetailsContext";
import { useToast } from "@/components/toast";

interface AddJdProps {
	file: any;
	setFile: any;
}
const JobDescriptionDoc: React.FC<AddJdProps> = ({ file, setFile }) => {
	const fileInputRef = useRef(null);
	const { jobDetails, setJobDetails } = useJobDetails()
	const toast = useToast();
	const handleBrowseClick = () => {
		if (fileInputRef.current !== null && fileInputRef.current !== undefined) {
			(fileInputRef.current as HTMLInputElement).click();
		}
	};
	return (
		<>
			<h3 className="mt-3 px-2 text-lg">Use Your Existing Job Description</h3>
			<p className="text-gray-600 my-2 px-2">Upload your JD file and proceed directly to assessment configuration.</p>

			<div className="mb-4 mt-3">
				<label className="text-gray-600 text-sm font-medium mb-1 block ">
					Job Role <span className="text-red-500">*</span>
				</label>
				<input
					required
					type="text"
					value={jobDetails?.title}
					onChange={(e) => setJobDetails({ ...jobDetails, title: e.target.value })}
					placeholder="Enter Job Role/Title"
					className="w-full px-4 py-2 border border-gray-300 rounded-lg "
				/>
			</div>
			<div className=" p-4 rounded-lg    bg-[#F8F8F8]    ">
				<div className="flex justify-center items-center h-[90%]">
					<div className=" ">
						{/* <h3 className="text-lg mb-2 font-semibold text-zinc-700">Add file(s)</h3> */}

						<input
							required
							type="file"
							ref={fileInputRef}
							className="hidden"
							onChange={(e) => {
								const selectedFile = e.target.files ? e.target.files[0] : null;
								if (selectedFile) {
									// Check file type
									if (selectedFile.type !== 'application/pdf') {
										toast.error({
											type: "background",
											duration: 5000,
											status: "error",
											title: "Invalid File Type",
											description: "Please select a PDF file.",
											open: true,
										});
										setFile(null);
										return;
									}
									// Check file size (5MB = 5 * 1024 * 1024 bytes)
									if (selectedFile.size > 5 * 1024 * 1024) {
										toast.error({
											type: "background",
											duration: 5000,
											status: "error",
											title: "File Too Large",
											description: "Please select a file smaller than 5MB.",
											open: true,
										});
										setFile(null);
										return;
									}
									setFile(selectedFile);
								}
								// Reset the input value to allow selecting the same file again
								if (e.target) {
									(e.target as HTMLInputElement).value = '';
								}
							}}
							accept=".pdf"
						/>
						<button
							onClick={handleBrowseClick}
							className="text-[#438437] bg-[#BDE4C3]  py-2 px-4 rounded hover:scale-110 transition"
						>
							Upload Document
						</button>
						<p className="text-sm text-center text-zinc-400 mt-2">(Only PDF files are supported)</p>
					</div>
				</div>
				{file && (
					<div className="flex items-center p-2 text-[#438437] bg-[#BDE4C3] rounded-lg mt-3">
						<div className="flex-grow">
							<p className=" font-semibold">{file ? file.name : ""}</p>
						</div>
						<div
							className="hover:scale-110 transition cursor-pointer text-xl"
							onClick={() => setFile(null)}
						>
							<FontAwesomeIcon icon={faTrash} />
						</div>
					</div>
				)}
			</div>
		</>
	);
};

export default JobDescriptionDoc;
